import React from 'react'

import { Column } from '@ant-design/plots'

type HistogramProps = {
  data: any[]
  filterBy?: string
  label?: object
  meta?: object
  xField?: string
  yField?: string
  yAxis?: object
  xAxis?: object
  columnStyle?: object
  style: object
}

const HistogramChart = ({ data, filterBy, xField, yField, ...props }: HistogramProps) => {
  const config = {
    data,
    xField: xField,
    yField: yField,
    seriesField: filterBy,
    columnStyle: props.columnStyle,
    xAxis: props.xAxis,
    yAxis: props.yAxis,
    style: props.style,
  }
  return <Column {...config} />
}

export default HistogramChart
